import axios from 'axios';
import { floorFieldValues } from 'pages/floorScreen/form/floorFields';
import { IFloor } from 'types/shared';
import { apiURL, QueryParams } from 'utils/constants';

const floorsURL = apiURL + 'Floors';
const AllfloorsURL = apiURL + 'Floors?limit=100';

const FloorsApiWrapper = {
	getFloors: (params?: QueryParams): Promise<IFloor[]> => {
		const floors = axios
			.get(AllfloorsURL, { params })
			.then((result) => {
				const floorsList = result.data as IFloor[];
				return floorsList.map((floor) => {
					return { ...floor, description: floor.description !== null ? floor.description : ''} 
				})	
				} 
			)
		return floors;
	},

	getBuildingFloors: (buildingId: number): Promise<IFloor[]> => {
		const floors = axios
			.get(`${apiURL}Buildings/${buildingId}/Floors`)
			.then((result) => result.data as IFloor[]);

		return floors;
	},

	deleteFloor: (floorId: number): Promise<boolean> => {
		const result = axios
			.delete(`${floorsURL}/${floorId}`)
			.then(() => true);

		return result;
	},

	getFloor: (floorId: number): Promise<IFloor> => {
		const result = axios
			.get(`${floorsURL}/${floorId}`)
			.then((result) => result.data as IFloor);

		return result;
	},

	postFloor: (floor: floorFieldValues): Promise<IFloor> => {
		return axios.post(floorsURL, floor).then((result) => result.data as IFloor);
	},

	putFloor: (floor: floorFieldValues) => {
		const result= axios.put(floorsURL, floor).then(() => true );

		return result;
	}
};

export default FloorsApiWrapper;
